// Uniforms de base
uniform float uProgress;
uniform float uTime;
uniform float uNoiseAmp;
uniform float uSeed;
uniform vec2 uRes;

// UNIFORMS POUR LA GUI
uniform float uThreshold1;
uniform float uThreshold2;
uniform float uNoiseMin;
uniform float uNoiseMax;
uniform float uAlphaWidth;
uniform float uDirection;

// Coordonnées de texture
varying vec2 vUv;

// --- Fonctions de Bruit ---
float mod289(float x) {
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec4 mod289(vec4 x) {
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec4 perm(vec4 x) {
    return mod289(((x * 34.0) + 1.0) * x);
}
float noise(vec3 p) {
    vec3 a = floor(p);
    vec3 d = p - a;
    d = d * d * (3.0 - 2.0 * d);
    vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
    vec4 k1 = perm(b.xyxy);
    vec4 k2 = perm(k1.xyxy + b.zzww);
    vec4 c = k2 + a.zzzz;
    vec4 k3 = perm(c);
    vec4 k4 = perm(c + 1.0);
    vec4 o1 = fract(k3 * (1.0 / 41.0));
    vec4 o2 = fract(k4 * (1.0 / 41.0));
    vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
    vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);
    return o4.y * d.y + o4.x * (1.0 - d.y);
}

#define OCTAVES 4
float fbm(vec3 p) {
    float total = 0.0;
    float frequency = 1.0;
    float amplitude = 0.5;
    float maxAmplitude = 0.0;
    for(int i = 0; i < OCTAVES; i++) {
        total += noise(p * frequency) * amplitude;
        maxAmplitude += amplitude;
        frequency *= 2.0;
        amplitude *= 0.5;
    }
    return total / maxAmplitude;
}
// --- Fin des fonctions de bruit ---

void main() {
    // --- 1. CALCUL DU BRUIT ET CORRECTION DU RYTHME ---
    vec2 finalUv = vUv + uSeed;

    float fbmValue = fbm(vec3(finalUv * uNoiseAmp, 0.0));

    // Correction du rythme. Pour que la transition s'étale,
    // uNoiseMin et uNoiseMax DOIVENT être rapprochés (ex: 0.4 et 0.6).
    float noiseValue = smoothstep(uNoiseMin, uNoiseMax, fbmValue);

    // --- 2. CALCUL DU MASQUE (FORMULE FINALE ET ROBUSTE) ---
    float directionalInfluence = 0.8;
    float noiseInfluence = 0.2; 

    float delay;
    if(uDirection == 1.0) {
        delay = (uDirection - vUv.y) * directionalInfluence + noiseValue * noiseInfluence;
    } else {
        delay = (vUv.y) * directionalInfluence + noiseValue * noiseInfluence;
    }

    // Le masque est maintenant un simple 'smoothstep' basé sur le progrès et le délai.
    float edgeSoftness = 0.05;
    float mask = smoothstep(delay - edgeSoftness, delay, uProgress);

    // --- 3. LOGIQUE DES BANDES DE COULEUR ---
    vec3 colorRed = vec3(1.0);
    vec3 colorGreen = vec3(0.878, 0.6, 0.945);
    vec3 colorBlue = vec3(0.176, 0., 0.216);

    vec3 finalColor;
    float finalAlpha;

    if(mask > uThreshold2) {
        finalColor = colorBlue;
        finalAlpha = 1.0;
    } else if(mask > uThreshold1) {
        finalColor = colorGreen;
        finalAlpha = 1.0;
    } else {
        finalColor = colorRed;

        float alphaStart = uThreshold1 - uAlphaWidth;
        float alphaEnd = uThreshold1;

        finalAlpha = smoothstep(alphaStart, alphaEnd, mask);
    }

    // --- 4. ASSEMBLAGE FINAL ---
    gl_FragColor = vec4(finalColor * finalAlpha, finalAlpha);
}
